import React from "react";
import { createPortal } from "react-dom";

const base = import.meta.env.BASE_URL || "/";

const styles = {
  wrap: {
    position: "fixed",
    inset: 0,
    backdropFilter: "blur(1.5px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
  },
  card: {
    minWidth: 148,
    background: "rgba(255,255,255,0.72)",
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 14,
    boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
    padding: "16px 22px 14px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    color: "#1b4332",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    backdropFilter: "blur(9px)",
    WebkitBackdropFilter: "blur(9px)",
  },
  logoWrap: {
    position: "relative",
    width: 116,
    height: 116,
    display: "grid",
    placeItems: "center",
  },
  logo: {
    width: 76,
    height: 76,
    objectFit: "contain",
    display: "block",
  },
  orbit: {
    position: "absolute",
    inset: 0,
  },
  dot: {
    position: "absolute",
    top: 54,
    left: 54,
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#198754",
    boxShadow: "0 1px 4px rgba(22,101,52,0.35)",
    opacity: 0.2,
    animation: "trekkin-loading-dot-orbit 1.28s linear infinite",
  },
};

const orbitDots = Array.from({ length: 16 }, (_, index) => ({
  transform: `rotate(${index * 22.5}deg) translateY(-52px)`,
  animationDelay: `${index * -80}ms`,
}));

export default function LoadingDotsOverlay({
  text = "A carregar...",
  zIndex = 6000,
  background = "rgba(0,0,0,0.18)",
}) {
  const overlay = (
    <>
      <div
        style={{ ...styles.wrap, zIndex, background }}
        aria-live="polite"
        aria-busy="true"
        role="status"
      >
        <div style={styles.card}>
          <span style={styles.logoWrap} aria-hidden="true">
            <img
              src={`${base}logo-trekkin.png`}
              alt=""
              style={styles.logo}
            />
            <span className="trekkin-loading-orbit" style={styles.orbit}>
              {orbitDots.map((dotStyle, index) => (
                <span
                  key={index}
                  style={{ ...styles.dot, ...dotStyle }}
                />
              ))}
            </span>
          </span>
          <span>{text}</span>
        </div>
      </div>
      <style>{`
        @keyframes trekkin-loading-dot-orbit {
          0%, 35%, 100% { opacity: 0.18; filter: brightness(0.8); }
          12% { opacity: 1; filter: brightness(1.35); }
        }
        @media (prefers-reduced-motion: reduce) {
          .trekkin-loading-orbit > span {
            animation-duration: 2.7s !important;
          }
        }
      `}</style>
    </>
  );

  // Leaflet and the panel stack use transformed ancestors. Rendering at the
  // document root keeps position:fixed relative to the physical viewport.
  return typeof document !== "undefined"
    ? createPortal(overlay, document.body)
    : overlay;
}
